import { Box } from '@mui/material';
import { FC } from 'react';
import { TCountryFlagProps } from './types';
import { COUNTRY_FLAG_HEIGHTS } from './constants';
import { getFlagCode } from './utils';

export const CountryFlag: FC<TCountryFlagProps> = ({
	countryCode,
	size = 'm',
	squared = false,
	sx = {},
}) => {
	return (
		<Box
			component="span"
			className={`fi fi-${getFlagCode(countryCode)}${squared ? ' fis' : ''}`}
			sx={{
				fontSize: `${COUNTRY_FLAG_HEIGHTS[size]}px`,
				flexShrink: 0,
				borderRadius: '1px',
				...sx,
			}}
		/>
	);
};
